import { donateHeroImage, donateHeroMobileImage } from "../images";

export const heroData = [
	{
		imageSource: [donateHeroImage, donateHeroMobileImage],
		heading: "Sponsor a Meal",
	},
];

export const donateData = [
	{
		title: "Why you should Donate for us",
		description:
			"Your generous support will go directly to providing support and assistance to our community’s most vulnerable including children, those living with a mental illness, victims of violence and the homeless. Help build our community and inspire hope today.",
	},
];
